import React, { useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import PropTypes from "prop-types";

const BulkApprovalModal = ({ show, onHide, onConfirm, action, selectedItems }) => {
    const [comments, setComments] = useState("");
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm(comments);
            setComments("");
            onHide();
        } catch (error) {
            console.error("Error in bulk approval:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setComments("");
        onHide();
    };

    const getButtonText = () => {
        const actionText = action === 'approve' ? 'Approve' : 'Reject';
        return `${actionText} ${selectedItems?.length || 0} Assignments`;
    };

    const getTitle = () => {
        return action === 'approve' ? 'Bulk Approve Assignments' : 'Bulk Reject Assignments';
    };

    const getMessage = () => {
        const actionText = action === 'approve' ? 'approve' : 'reject';
        return `Are you sure you want to ${actionText} ${selectedItems?.length || 0} selected assignments?`;
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered className="modalDeleteWrapper">
            <Modal.Header closeButton>
                <Modal.Title>{getTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant={action === 'approve' ? 'success' : 'warning'}>
                    <i className={`fa ${action === 'approve' ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-2`} style={{marginRight: 3}}></i>
                    {getMessage()}
                </Alert>

                {selectedItems && selectedItems.length > 0 && (
                    <div className="mb-3">
                        <strong>Selected Assignments ({selectedItems.length}):</strong>
                        <div className="mt-2 max-height-200 overflow-auto">
                            {selectedItems.map((item) => (
                                <div key={item.id} className="border-bottom py-1">
                                    <div><strong>ID:</strong> {item.carrierConnectNumber}</div>
                                    <div><strong>From:</strong> {item.oldCompanySellerName}</div>
                                    <div><strong>To:</strong> {item.companySellerName}</div>
                                    <div><strong>Carrier:</strong> {item.carrierName}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <Alert variant="info" className="mt-3 mb-0">
                    <i className="fa fa-info-circle me-2" style={{marginRight: 3}}></i>
                    <strong>Note:</strong> This action will be applied to all selected assignments and cannot be undone.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    variant={action === 'approve' ? 'success' : 'danger'}
                    onClick={handleConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                            {'Approving...'}
                        </>
                    ) : (
                        getButtonText()
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

BulkApprovalModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    action: PropTypes.oneOf(['approve']).isRequired,
    selectedItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            assignmentId: PropTypes.string,
            fromCompany: PropTypes.string,
            fromSeller: PropTypes.string,
            toCompany: PropTypes.string,
            toSeller: PropTypes.string,
            carrierConnectId: PropTypes.string,
            carrierName: PropTypes.string
        })
    )
};

export default BulkApprovalModal;